import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import PhoneInput from 'react-phone-number-input';
import Select from 'react-select';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from './../../../UseToken';
import Loader from '../../Loader/Loader';
import Swal from 'sweetalert2'
import Hosts from '../../../Hosts';
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,
	pattern_vat,
	pattern_email,
	passwordHash,
	translate,
	handle_compressed_image_upload,
	set_language
} from '../../../Utils';

import { language } from './Language';
import { color } from '../../WEBContent/Color';

const modalStyles = {
	modalOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		backgroundColor: color.corShadow.rgba2,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 1000,
	},
	modalContent: {
		backgroundColor: color.cor3.hexa,
		padding: '20px',
		borderRadius: '10px',
		width: '600px',
		maxWidth: '90%',
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'relative',
		overflow: 'hidden',
	},
	taskListContainer: {
		flex: 1,
		width: '100%',
		padding: '10px 15px',
		textAlign: 'start',
	},
	buttonContainer: {
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		marginTop: '15px',
	},
	closeButton: {
		padding: '10px 20px',
		border: 'none',
		borderRadius: '5px',
		cursor: 'pointer',
		backgroundColor: color.cor1.hexa,
		fontSize: '16px',
	},
};

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);
	const [lang_id, set_lang_id] = useState('1');
	const [is_password, set_is_password] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	//const [disabled, set_disabled] = useState(true)
	const [/*is_input_disabled*/, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	// Lista de todas as entidades (usada para derivar Direção e Atletas deste clube)
	const [entities, setEntities] = useState([]);

	// ===== Modal "Associar Entidade" (Interna ou Externa) ao clube =====
	const [showAssociarModal, setShowAssociarModal] = useState(false);
	const [associarSearch, setAssociarSearch] = useState('');
	const [associarResults, setAssociarResults] = useState([]);
	const [associarLoading, setAssociarLoading] = useState(false);
	const [selectedEntityToAssociate, setSelectedEntityToAssociate] = useState(null);

	//Logo
	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);
	const [photo_base64, set_photo_base64] = useState('');
	const [img_loader, set_img_loader] = useState([])

	// Documentos do clube (Contrato Programa, Estatutos, Acta de tomada de posse, declarações SS/AT)
	const [files_doc, set_files_doc] = useState([]);

	// Morada (local, código postal, freguesia, concelho, distrito, país)
	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])
	const [show_district_city_village, set_show_district_city_village] = useState('')

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				//console.log(getTokenInfo().profile)

				if (res.data[0].profile.name === 'Administrador') {
					if (getTokenInfo().profile === 'Administrador') {
						set_dados(dados.current = ensure_address(res.data[0]));
					} else {
						setRedirect(true);
					}
				}
				else {
					set_dados(dados.current = ensure_address(res.data[0]));
				}

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	// Garante que addresses[0] existe com os campos usados pela morada do clube,
	// mesmo que o data_interface ainda não os tenha definidos.
	const ensure_address = (d) => {
		if (!Array.isArray(d.addresses) || d.addresses.length === 0) {
			d.addresses = [{}]
		}
		d.addresses[0] = {
			localidade: '',
			postal_code: '',
			village: '',
			city: '',
			region: '',
			country: '',
			address_detail: '',
			...d.addresses[0]
		}
		return d
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.office = getTokenInfo().office)
		set_dados(dados.current = ensure_address(dados.current))
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();

		set_lang(localStorage.getItem('lang'))

		obter_paises_em_pt(set_countries)

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_input_disabled(false)
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)

					if (dados.current.addresses?.[0]?.country === 'Portugal') {
						obter_distritos_pt(set_districts)
						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)
						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					}
					else if (dados.current.addresses?.[0]?.country) {
						set_show_district_city_village('d-none')
					}
				})
				return
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPUT(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								files_doc.forEach(async (el_doc) => {
									if (el_doc !== null) {
										await uploadFilesDoc(el_doc.files, el_doc.field)
									}
								})
								set_files_doc([])

								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {
						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								files_doc.forEach(async (el_doc) => {
									if (el_doc !== null) {
										await uploadFilesDoc(el_doc.files, el_doc.field)
									}
								})
								set_files_doc([])

								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}
	}

	const handleSubmitConfig = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {
						reqPUT(api_crud_route, dados.current)
							.then(() => { props.history.push(endpoints.list) })
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {
						let password = dados.current.info.password;
						dados.current.info.password = passwordHash(password);

						reqPOST(api_crud_route, dados.current)
							.then(() => { props.history.push(endpoints.list) })
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})

		}
	}

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							props.history.push(endpoints.list);
						})
						.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
				}
			})
	};

	const load_entity = async (field, value, entity) => {
		let search_string = ''

		if (entity === '') {
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/*`
		}
		else
			search_string = `${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`

		reqGET(search_string)
			.then(res => {

				let ja_existe = false
				res.data.forEach((k) => {
					if (k[field] === value && value !== '') {

						ja_existe = true
					}
				})

				if (ja_existe === false) {
					set_is_input_disabled(true)

					if (field === 'username') {
						set_is_input_disabled(false)
					}
					return

				} else {
					//set_disabled(true)

					Swal.fire({
						title: language[lang].warning_title,
						text: language[lang].warning_text,
						icon: 'warning',
						showCancelButton: false,
						confirmButtonColor: '#0095e8',
						cancelButtonColor: '#d9214e',
						confirmButtonText: language[lang].warning_confirm,
						cancelButtonText: language[lang].warning_cancel
					})
						.then((result) => {
							if (result.isConfirmed) {
								set_is_input_disabled(true)
								//set_disabled(false)
								document.getElementById('username').style.color = 'red';
							}
						})

				}
			})
	}

	// uploadFile agora aceita um "field" genérico (ex: 'logo', 'contrato_programa',
	// 'estatutos', 'acta_tomada_posse', 'declaracoes_ss', 'declaracoes_at', ...)
	// e guarda sempre o resultado em dados.current.info[field]
	const uploadFile = async (file, field) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				const file_meta = {
					name: file.name,
					type: file.type,
					size: file.size,
					path: res.data.path,
					source_name: res.data.name,
					link: res.data.path + '' + res.data.name,
				};

				set_dados(dados.current.info[field] = [file_meta]);

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

						let y2 = img_loader
						y2.pop()
						set_img_loader(y2)
						setRefresh(i)

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const change_lang = (l) => {
		set_language(l)
		set_lang(l)

		//console.log('language', localStorage.getItem('lang'))
		//console.log('localstorage', localStorage)
	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		if(name === 'email') {
			set_dados(dados.current.contacts[0][name] = value)
		}

		set_dados(dados.current.info[name] = value)
	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	// ================= MORADA =================
	// Campos livres (local / código postal) dentro de addresses[0]
	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;
		set_dados(dados.current.addresses[addresses_index][name] = value)
	}

	const change_country = (e) => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === 'Portugal') {

			set_show_district_city_village('')

			if (districts.length === 0) {
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = (e) => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = (e) => {
		set_villages([])
		obter_freguesias_por_cidade(e.value, set_villages)
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = (e) => {
		set_dados(dados.current.addresses[0].village = e.value);
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if (new_password === value) {
			set_is_password(true)
			//set_disabled(false)
		}
		else {
			Swal.fire(language[lang].password_text, '', 'info')
			set_is_password(false)
			//set_disabled(true)
		}
	}

	const handleSingleCheckDarkmode = (e) => {
		if (dados.current.info['darkmode'] === true) {
			set_dados(dados.current.info['darkmode'] = false)
			//set_darkmode(false)
		}
		else {
			set_dados(dados.current.info['darkmode'] = true)
			//set_darkmode(true)
		}
	}

	const onChangeHandlerFilesImage = async (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);
		let files_img_aux = image_base64

		let k = 0
		for await (let v of filesArray) {
			if ((v.type.includes('image/')) && (v.size < 10485760)) {

				await handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))

				await convertBase64(v)
					.then((base64) => {

						if (files_img_aux[order] === undefined)
							files_img_aux[order] = []
						if (files_img_aux[order][langid] === undefined)
							files_img_aux[order][langid] = []

						files_img_aux[order][langid].push({ id: '1', langid: langid, name: v.name.split('.')[0] + '.webp', link: base64 })
						set_image_base64(files_img_aux)
						set_photo_base64(base64)
						setRefresh(refresh + Math.random())
					})


				if (filesArray.length === (k + 1)) {
					setRefresh(refresh + parseInt(v.size) + k)
				}

			}
			else {
				Swal.fire(language[lang].upload_image_error + v.name, '', 'info')
			}

			k++
		}

		let files_aux = files_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_image(files_aux)

	}

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const handleFileRemove = () => {

		set_dados(dados.current.info.logo = [])
		set_photo_base64('')
		set_image_base64([])

	};

	const uploadFilesImage = async (files, order, type, langid, lang) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				await uploadFile(element, 'logo')
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	// ================= DOCUMENTOS DO CLUBE =================
	// (Contrato Programa, Estatutos, Acta de tomada de posse, declarações SS/AT)
	// "field" identifica onde o ficheiro fica guardado em dados.current.info[field]
	const onChangeHandlerFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { field } = dataset;

		let filesArray = Array.prototype.slice.call(files);
		let storedFiles = [];

		filesArray.forEach((v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				// Mostra já uma linha na árvore (SortableTree) com o nome do
				// ficheiro escolhido, mesmo antes do upload real acontecer —
				// o link fica preenchido a seguir, quando o formulário for
				// gravado e uploadFile() substituir esta entrada pela real.
				set_dados(dados.current.info[field] = [{
					name: v.name,
					type: v.type,
					size: v.size,
					link: '',
				}])
			}
			else {
				Swal.fire((language[lang].upload_file_error ?? 'Formato do ficheiro incorrecto: ') + v.name, '', 'info')
			}
		});

		if (storedFiles.length > 0) {
			let files_aux = files_doc
			files_aux.push({ files: storedFiles, field: field })
			set_files_doc(files_aux)
			setRefresh(refresh + 1)
		}
	}

	const uploadFilesDoc = async (files, field) => {
		files.forEach((element) => {
			if (element.type === 'application/pdf') {
				uploadFile(element, field)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const handleDocRemove = (field) => {
		set_dados(dados.current.info[field] = [])
		setRefresh(refresh + 1)
	};

	// Renomear o ficheiro diretamente na árvore (SortableTree), tal como no
	// Cliente Regist.js — só atualiza o "name" apresentado, não o ficheiro em si.
	const edit_element_tree_doc = (field, e) => {
		const { value } = e.target;
		if (Array.isArray(dados.current.info[field]) && dados.current.info[field][0]) {
			dados.current.info[field][0].name = value
			set_dados(dados.current.info[field])
			setRefresh(refresh + 1)
		}
	}

	const open_link = (url) => {
		if (url) window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		if (!url) return
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	// ================= MODALIDADES DO CLUBE =================
	const modalidades_lista = [
		{ value: 'ski_de_fundo', label: 'Esqui de Fundo' },
		{ value: 'curling', label: 'Curling' },
		{ value: 'ski_alpino', label: 'Esqui alpino' },
		{ value: 'bobsled', label: 'Bobsled' },
		{ value: 'hoquei_no_gelo', label: 'Hóquei no gelo' },
		{ value: 'luge', label: 'Luge' },
		{ value: 'snowboard', label: 'Snowboard' },
		{ value: 'skeleton', label: 'Skeleton' },
		{ value: 'patinacao_artistica', label: 'Patinação artística' },
		{ value: 'patinacao_de_velocidade', label: 'Patinação de velocidade' },
		{ value: 'ski_freestyle', label: 'Esqui Free Style' },
		{ value: 'biatlo', label: 'Biatlo' },
	];

	const change_modalidades = (selected) => {
		set_dados(dados.current.info.modalidades = selected || []);
	};

	// ================= REPRESENTANTES (Presidente / Direção) =================
	const change_presidente = (e) => {
		const selectedId = e.target.value;
		const selected = board_members.find(el => String(el.id) === String(selectedId));

		set_dados(dados.current.info.presidente = selected
			? { id: selected.id, label: selected.info?.name ?? '' }
			: { id: '', label: '' });
	};

	const getAnoEpocaAtual = () => {
		const hoje = new Date();
		const anoAtual = hoje.getFullYear();
		const mesAtual = hoje.getMonth();
		return mesAtual >= 6 ? anoAtual : anoAtual - 1;
	};

	const epoca_atual = `${getAnoEpocaAtual()}/${getAnoEpocaAtual() + 1}`;

	// ================= ENTIDADES DO CLUBE (Direção / Atletas) =================

	const fetch_entities = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`);
			setEntities(res.data);

		} catch (error) {
			console.error("Erro ao buscar as entities:", error);
		}
	};

	const fetchAndDisplayData = async () => {
		await fetch_entities();
	};

	useEffect(() => {
		fetchAndDisplayData();
	}, []);

	// ===== Pesquisa de entidades (Interna ou Externa) para associar ao clube =====
	// Apenas entidades com entity_type "1" ou "2" podem ser associadas (as restantes
	// não fazem sentido substituir o dados.info.clube).
	const has_valid_entity_type = (e) => {
		const et = e?.entity_type;
		const etArr = Array.isArray(et) ? et.map(String) : (et !== undefined && et !== null && et !== '' ? [String(et)] : []);
		return etArr.includes('1') || etArr.includes('2');
	};

	const search_entities_to_associate = async (term) => {
		setAssociarLoading(true)
		try {
			// Todas as entidades da empresa (Internas + Externas)
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`)
			const t = (term || '').toLowerCase()
			const filtered = (res.data || []).filter(e => {
				const nome = (e?.info?.name ?? e?.name ?? '').toLowerCase()
				return has_valid_entity_type(e) && (t === '' || nome.includes(t))
			})
			setAssociarResults(filtered)
		} catch (error) {
			console.error('Erro ao pesquisar entidades:', error)
		} finally {
			setAssociarLoading(false)
		}
	}

	useEffect(() => {
		if (showAssociarModal) {
			search_entities_to_associate(associarSearch)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showAssociarModal])

	const handle_associar_search_change = (e) => {
		const value = e.target.value
		setAssociarSearch(value)
		search_entities_to_associate(value)
	}

	const handleCloseAssociarModal = () => {
		setShowAssociarModal(false)
		setSelectedEntityToAssociate(null)
		setAssociarSearch('')
	}

	// Devolve sempre um array de clubes, aceitando o formato antigo (objeto
	// único) ou o novo (array), para não rebentar com dados legados.
	const get_clubes_entidade = (entidade) => {
		const c = entidade?.info?.clube ?? entidade?.clube
		if (Array.isArray(c)) return c
		if (c && c.id) return [c]
		return []
	}

	const associar_entidade_ao_clube = (entidade) => {

		// Não é possível associar a um clube que ainda não foi gravado (sem id).
		if (!dados.current?.id) {
			Swal.fire(language[lang].associar_precisa_gravar ?? 'Grave o clube primeiro para poder associar entidades', '', 'info')
			return
		}

		const nome_entidade = entidade?.info?.name ?? entidade?.name ?? ''
		const clubes_atuais = get_clubes_entidade(entidade)
		const ja_esta_neste_clube = clubes_atuais.some(c => String(c?.id ?? '') === String(dados.current.id))
		const outros_clubes = clubes_atuais.filter(c => String(c?.id ?? '') !== String(dados.current.id))

		console.log('Associar a entidade a um clube', { nome_entidade, clubes_atuais, ja_esta_neste_clube })

		if (ja_esta_neste_clube) {
			Swal.fire('', language[lang].associar_ja_neste_clube ?? 'Esta entidade já está associada a este clube', 'info')
			return
		}

		// Agora a associação é aditiva: uma entidade pode pertencer a vários
		// clubes ao mesmo tempo — associar aqui não remove os outros clubes
		// a que já pertença, só acrescenta este.
		const texto_html = outros_clubes.length > 0
			? `${language[lang].associar_text_multi ?? 'A entidade'} <b>${nome_entidade}</b> ${language[lang].associar_text_multi_2 ?? 'já está associada a'} <b>${outros_clubes.map(c => c.name ?? c.label).join(', ')}</b>. ${language[lang].associar_text_multi_3 ?? 'Ao confirmar, fica também associada a este clube (mantém os restantes).'}`
			: `${language[lang].associar_text ?? 'Confirma associar'} <b>${nome_entidade}</b> ${language[lang].associar_text_2 ?? 'a este clube?'}`

		Swal.fire({
			title: language[lang].associar_title ?? 'Associar entidade ao clube',
			html: texto_html,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].associar_confirm ?? 'Associar',
			cancelButtonText: language[lang].associar_cancel ?? 'Cancelar'
		})
			.then(async (result) => {
				if (result.isConfirmed) {
					try {
						// A pesquisa devolve um objeto "achatado" (sem .info completo).
						// Vamos buscar a entidade completa antes de gravar — é esta
						// forma que o endpoint de escrita espera (confirmado: o GET
						// por id devolve a estrutura certa, com info/addresses/contacts/profile).
						const full = await reqGET(`${Hosts.SIMCore_API}/entities/${getTokenInfo().companycode}/${entidade.id}`)
						const entidade_completa = Array.isArray(full?.data) ? full.data[0] : (full?.data ?? entidade)

						let entidade_atualizada = JSON.parse(JSON.stringify(entidade_completa))
						if (entidade_atualizada.info === undefined) entidade_atualizada.info = {}

						const clubes_existentes = get_clubes_entidade(entidade_atualizada)
						entidade_atualizada.info.clube = [
							...clubes_existentes,
							{ id: dados.current.id, name: dados.current.info.name }
						]

						console.log('PUT entities - payload enviado', entidade_atualizada)

						reqPUT(`${Hosts.SIMCore_API}/entities`, entidade_atualizada)
							.then((res) => {
								console.log('PUT entities - resposta', res)
								Swal.fire('', language[lang].associar_success ?? 'Entidade associada com sucesso', 'success')
								handleCloseAssociarModal()
								fetch_entities()
							})
							.catch((err) => {
								console.log('PUT entities - erro', err)
								Swal.fire(language[lang].associar_error ?? 'Não foi possível associar a entidade', '', 'info')
							})

					} catch (error) {
						console.log('GET entidade completa - erro', error)
						Swal.fire(language[lang].associar_error ?? 'Não foi possível associar a entidade', '', 'info')
					}
				}
			})
	}

	// ID deste clube (registo atual)
	const club_id = dados.current?.id;

	// Todas as entidades associadas a este clube.
	// Só faz sentido comparar se este clube já tiver sido gravado (club_id não vazio) —
	// caso contrário, entidades sem clube (clube.id === '') ficavam a "pertencer"
	// a qualquer clube novo por ambos terem id vazio.
	const club_entities = club_id
		? (entities || []).filter(e => {
			const clubes = Array.isArray(e?.info?.clube) ? e.info.clube : (e?.info?.clube ? [e.info.clube] : []);
			return clubes.some(c => String(c?.id ?? '') === String(club_id));
		})
		: [];

	const get_entity_type_label = (e) => {
		const cat = e?.info?.attributes?.entity_category;
		const val = Array.isArray(cat) ? cat[0] : cat;
		return String(val) === '1'
			? (language[lang].interna ?? 'Interna')
			: (language[lang].externa ?? 'Externa');
	};

	const get_entity_profiles = (e) => {
		const pf = e?.info?.attributes?.entity_profile;
		if (!Array.isArray(pf)) return [];
		return pf.map(item =>
			typeof item === 'object' && item !== null
				? { id: String(item.id ?? ''), label: String(item.label ?? '').toLowerCase() }
				: { id: String(item ?? ''), label: '' }
		);
	};

	const is_athlete = (e) =>
		get_entity_profiles(e).some(p => p.label.includes('praticante'));

	const is_board_member = (e) =>
		get_entity_profiles(e).some(p =>
			p.label.includes('presidente') ||
			p.label.includes('direção') ||
			p.label.includes('direcao') ||
			p.label.includes('diretor') ||
			p.label.includes('director')
		);

	const get_athlete_modalidades = (e) => {
		const mods = e?.info?.modalidades;
		if (!Array.isArray(mods)) return '';
		return mods.map(m => m.label ?? m.value ?? m).join(', ');
	};

	const get_athlete_numero_federacao = (e) =>
		e?.info?.numero_federacao ?? e?.info?.numero_licenca ?? e?.info?.numero_atleta ?? '';

	// Perfis da entidade, em texto, mantendo a capitalização original (para apresentação)
	const get_entity_profile_labels = (e) => {
		const pf = e?.info?.attributes?.entity_profile;
		if (!Array.isArray(pf)) return '';
		return pf.map(item => (typeof item === 'object' && item !== null ? item.label : item)).filter(Boolean).join(', ');
	};

	const board_members = club_entities.filter(is_board_member);
	const athletes = club_entities.filter(is_athlete);

	// Outros Atletas / Outras Entidades: ligadas ao clube (info.clube.id) mas que não
	// se enquadram em "Direção" (presidente/direção) nem em "Atletas" (praticantes) —
	// ex.: entidades externas associadas sem um perfil "Praticante" definido.
	const other_entities = club_entities.filter(e => !is_board_member(e) && !is_athlete(e));

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].entity}</h2>
					<p>{language[lang].entity} / {dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">

						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_info">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div id="div_entidade_info" className="collapse show">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">
												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].name}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].data_constituicao}</label>
														<input type="date" name="data_constituicao" value={dados.current.info.data_constituicao} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].data_constituicao_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-md-4">
														<label className="fs-6 fw-bold mb-2">{language[lang].data_filiacao}</label>
														<input type="date" name="data_filiacao" value={dados.current.info.data_filiacao} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].data_constituicao_placeholder} onChange={handle_change_info} required />
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].vat}</label>
														<input type="text"
															pattern={pattern_vat}
															minLength="9"
															inputMode='numeric'
															name="vat"
															value={dados.current.info.vat}
															className="form-control rounded-0"
															placeholder={language[lang].vat_placeholder}
															onChange={handle_change_info}
														/>
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].email}</label>
														<input type="email" pattern={pattern_email} name="email" value={(dados.current.info.email != undefined && dados.current.info.email != '' ? dados.current.info.email : dados.current.contacts[0].email) || ''} className="form-control rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_info} />
													</div>

													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].phone}</label>
														<PhoneInput
															defaultCountry="PT"
															className="form-control rounded-0"
															placeholder={language[lang].phone_placeholder}
															value={dados.current.info.phone !== '' ? dados.current.info.phone : null}
															onChange={e => set_dados(dados.current.info.phone = e)}
														/>
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-8">
														<label className="form-label fw-bold fs-6">{language[lang].morada}</label>
														<textarea name="address_detail" value={dados.current.addresses[0].address_detail || ''} className="form-control rounded-0" rows="3" onChange={handle_change_addresses} />
													</div>

													<div className="col-md-4 mb-3 p-4 bg-white shadow-sm rounded">
														<label className="form-label fw-bold fs-6 d-block">{language[lang].logo}</label>
														<ul className="list-unstyled d-flex flex-wrap gap-3 mt-3 justify-content-center">
															{
																photo_base64 !== '' ?
																	<img
																		src={photo_base64}
																		className="img-fluid rounded"
																		alt="Uploaded"
																		style={{ width: "120px", height: "120px", objectFit: "cover" }}
																	/>
																	:
																	dados?.current?.info?.logo?.length > 0 ? (
																		dados.current.info.logo.map((file, index) => {
																			const imageURL = file.link || URL.createObjectURL(file);
																			return (
																				<li key={index} className="d-flex flex-column align-items-center">
																					<img
																						src={imageURL}
																						className="img-fluid rounded"
																						alt="Uploaded"
																						style={{ width: "120px", height: "120px", objectFit: "cover" }}
																					/>
																					<small className="mt-2 text-muted d-none">{file.name || 'Imagem'}</small>
																				</li>
																			);
																		})
																	) : (
																		<li className="text-muted">{language[lang].noLogo}</li>
																	)}
														</ul>

														<div className="d-flex justify-content-center mt-4 gap-2">
															<input
																type="file"
																accept="image/*"
																onChange={onChangeHandlerFilesImage}
																data-order={1}
																data-langid={lang_id}
																data-lang={lang}
																data-type={'image'}
																className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																id="logo-upload"
															/>

															<label htmlFor="logo-upload" className="btn btn-outline-primary btn-sm">
																{language[lang].logo_choose}
															</label>

															{dados?.current?.info?.logo?.length > 0 && (
																<button
																	type="button"
																	onClick={handleFileRemove}
																	style={{
																		marginLeft: "5px",
																		backgroundColor: color.corVermelha.rgb,
																		color: "#FFF",
																		border: "none",
																		borderRadius: "5px",
																		cursor: "pointer",
																		padding: "3px 10px",
																	}}
																>
																	X
																</button>
															)}
														</div>
													</div>
												</div>

												<div className="row g-3 mb-4">
													<div className="col-md-4">
														<label className="form-label fw-bold fs-6">{language[lang].local}</label>
														<input type="text" name="localidade" value={dados.current.addresses[0].localidade || ''} className="form-control rounded-0" placeholder={language[lang].local_placeholder} onChange={handle_change_addresses} />
													</div>

													<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === '' || dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
														<label className="form-label fw-bold fs-6">{language[lang].postal_code}</label>
														<input type="text" name="postal_code" value={dados.current.addresses[0].postal_code || ''} className="form-control rounded-0" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_addresses} />
													</div>

													<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === '' || dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
														<label className="form-label fw-bold fs-6">{language[lang].village}</label>
														<Select
															className="div-select"
															options={villages}
															name="freguesia"
															value={dados.current.addresses[0].village === '' ? null : { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }}
															placeholder={language[lang].village_placeholder}
															onChange={change_village}
														/>
													</div>

													<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === '' || dados.current.addresses[0].country.toLowerCase() === 'portugal' ? ' d-none' : '')}>
														<label className="form-label fw-bold fs-6">{language[lang].country}</label>
														<Select
															className="div-select"
															options={countries}
															name="pais"
															value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
															placeholder={language[lang].country_placeholder}
															onChange={change_country}
														/>
													</div>
												</div>

												<div className={"row g-3 mb-4 " + show_district_city_village}>
													<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === '' || dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
														<label className="form-label fw-bold fs-6">{language[lang].city}</label>
														<Select
															className="div-select"
															options={cities}
															name="concelho"
															value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
															placeholder={language[lang].city_placeholder}
															onChange={change_city}
														/>
													</div>

													<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === '' || dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
														<label className="form-label fw-bold fs-6">{language[lang].district}</label>
														<Select
															className="div-select"
															options={districts}
															name="distrito"
															value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
															placeholder={language[lang].district_placeholder}
															onChange={change_district}
														/>
													</div>

													<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === '' || dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
														<label className="form-label fw-bold fs-6">{language[lang].country}</label>
														<Select
															className="div-select"
															options={countries}
															name="pais"
															value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
															placeholder={language[lang].country_placeholder}
															onChange={change_country}
														/>
													</div>
												</div>

												{/* --- Modalidades --- */}
												<div className="row g-3 mb-4">
													<div className="col-md-8">
														<label className="form-label fw-bold fs-6">{language[lang].modalidades ?? 'Modalidades'}</label>
														<Select
															isMulti
															className="div-select"
															options={modalidades_lista}
															name="modalidades"
															value={
																Array.isArray(dados.current.info.modalidades)
																	? dados.current.info.modalidades.map(m => ({
																		label: m.label ?? m,
																		value: m.value ?? m,
																	}))
																	: []
															}
															placeholder={language[lang].modalidades_placeholder ?? 'Selecione as modalidades'}
															onChange={change_modalidades}
														/>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>

								{/* --- Presidentes e Direção --- */}
								<div className="card mt-5">
									<div className="card-header border-0 d-flex justify-content-between align-items-center">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].direcao_clube ?? 'Presidentes e Direção'}</h3>
										</div>
										<button
											type="button"
											className="btn btn-sm btn-primary"
											disabled={!dados.current?.id}
											title={!dados.current?.id ? (language[lang].associar_precisa_gravar ?? 'Grave o clube primeiro para poder associar entidades') : ''}
											onClick={() => setShowAssociarModal(true)}
										>
											<i className="bi bi-person-plus me-2"></i>
											{language[lang].associar_entidade ?? 'Associar Entidade'}
										</button>
									</div>
									<div className="card-body border-top p-4">

										<div className="row g-3 mb-4">
											<div className="col-md-6">
												<label className="form-label fw-bold fs-6">{language[lang].presidente ?? 'Presidente'}</label>
												<select
													name="presidente"
													className="form-select rounded-0"
													value={dados?.current?.info?.presidente?.id ?? ''}
													onChange={change_presidente}
												>
													<option value="">{language[lang].select ?? 'Selecione'}</option>
													{board_members.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{el.info?.name}
														</option>
													))}
												</select>
											</div>
										</div>

										<ClubEntitiesTable
											entities={board_members}
											language={language}
											lang={lang}
											get_athlete_numero_federacao={get_athlete_numero_federacao}
											get_entity_profile_labels={get_entity_profile_labels}
											get_athlete_modalidades={get_athlete_modalidades}
											get_entity_type_label={get_entity_type_label}
											epoca_atual={epoca_atual}
											highlightId={dados?.current?.info?.presidente?.id}
											highlightLabel={language[lang].presidente ?? 'Presidente'}
										/>
									</div>
								</div>

								{/* --- Atletas --- */}
								<div className="card mt-5">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].atletas ?? 'Atletas'}</h3>
										</div>
									</div>
									<div className="card-body border-top p-4">
										<ClubEntitiesTable
											entities={athletes}
											language={language}
											lang={lang}
											get_athlete_numero_federacao={get_athlete_numero_federacao}
											get_entity_profile_labels={get_entity_profile_labels}
											get_athlete_modalidades={get_athlete_modalidades}
											get_entity_type_label={get_entity_type_label}
											epoca_atual={epoca_atual}
										/>
									</div>
								</div>

								{/* --- Outros Atletas / Outras Entidades --- */}
								<div className="card mt-5">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].outros_atletas ?? 'Outros Atletas'}</h3>
										</div>
									</div>
									<div className="card-body border-top p-4">
										<ClubEntitiesTable
											entities={other_entities}
											language={language}
											lang={lang}
											get_athlete_numero_federacao={get_athlete_numero_federacao}
											get_entity_profile_labels={get_entity_profile_labels}
											get_athlete_modalidades={get_athlete_modalidades}
											get_entity_type_label={get_entity_type_label}
											epoca_atual={epoca_atual}
										/>
									</div>
								</div>

								{/* --- Modal: Associar Entidade (Interna ou Externa) ao clube --- */}
								{showAssociarModal && (
									<div style={modalStyles.modalOverlay} onClick={handleCloseAssociarModal}>
										<div style={modalStyles.modalContent} onClick={(e) => e.stopPropagation()}>
											<div style={modalStyles.taskListContainer}>
												<label className="form-label fw-bold fs-6">{language[lang].pesquisar_entidade ?? 'Pesquisar'}</label>
												<input
													type="text"
													className="form-control mb-3"
													placeholder={language[lang].pesquisar_entidade_placeholder ?? 'Pesquisar por nome...'}
													value={associarSearch}
													onChange={handle_associar_search_change}
												/>

												<select
													className="form-select"
													size={8}
													value={selectedEntityToAssociate?.id ?? ''}
													onChange={(e) => {
														const found = associarResults.find(el => String(el.id) === String(e.target.value))
														setSelectedEntityToAssociate(found ?? null)
													}}
												>
													<option value="">
														{associarLoading ? (language[lang].loading ?? 'A carregar...') : (language[lang].field_choose ?? 'Selecione')}
													</option>
													{associarResults.map((el, k) => (
														<option key={el.id ?? k} value={el.id}>
															{(el.info?.name ?? el.name)}
														</option>
													))}
												</select>
											</div>

											<div style={modalStyles.buttonContainer}>
												<button type="button" onClick={handleCloseAssociarModal}>
													{language[lang].cancel ?? 'Cancelar'}
												</button>
												<button
													type="button"
													style={{ ...modalStyles.closeButton, marginLeft: '10px', backgroundColor: color.corPrimaria?.hexa ?? '#0095e8', color: '#FFF' }}
													disabled={!selectedEntityToAssociate}
													onClick={() => associar_entidade_ao_clube(selectedEntityToAssociate)}
												>
													{language[lang].associar_confirm ?? 'Associar'}
												</button>
											</div>
										</div>
									</div>
								)}

								{/* --- Contrato Programa --- */}
								<div className="card mt-5">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].contrato_programa ?? 'Contrato Programa'}</h3>
										</div>
									</div>
									<div className="card-body border-top p-4">
										<DocUploadField
											field="contrato_programa"
											label={language[lang].contrato_programa ?? 'Contrato Programa'}
											dados={dados}
											language={language}
											lang={lang}
											onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
											handleDocRemove={handleDocRemove}
											edit_element_tree_doc={edit_element_tree_doc}
											open_link={open_link}
											copy_clipboard={copy_clipboard}
										/>
									</div>
								</div>

								{/* --- Upload de ficheiros (Estatutos, Acta de tomada de posse, declarações SS/AT) --- */}
								<div className="card mt-5">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].upload_de_ficheiros ?? 'Upload de ficheiros'}</h3>
										</div>
									</div>
									<div className="card-body border-top p-4">
										<div className="row g-4">
											<div className="col-md-6">
												<DocUploadField
													field="estatutos"
													label={language[lang].estatutos ?? 'Estatutos'}
													dados={dados}
													language={language}
													lang={lang}
													onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
													handleDocRemove={handleDocRemove}
													edit_element_tree_doc={edit_element_tree_doc}
													open_link={open_link}
													copy_clipboard={copy_clipboard}
												/>
											</div>
											<div className="col-md-6">
												<DocUploadField
													field="acta_tomada_posse"
													label={language[lang].acta_tomada_posse ?? 'Acta de tomada de posse'}
													dados={dados}
													language={language}
													lang={lang}
													onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
													handleDocRemove={handleDocRemove}
													edit_element_tree_doc={edit_element_tree_doc}
													open_link={open_link}
													copy_clipboard={copy_clipboard}
												/>
											</div>
											<div className="col-md-6">
												<DocUploadField
													field="declaracoes_ss"
													label={language[lang].declaracoes_ss ?? 'Declarações SS'}
													dados={dados}
													language={language}
													lang={lang}
													onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
													handleDocRemove={handleDocRemove}
													edit_element_tree_doc={edit_element_tree_doc}
													open_link={open_link}
													copy_clipboard={copy_clipboard}
												/>
											</div>
											<div className="col-md-6">
												<DocUploadField
													field="declaracoes_at"
													label={language[lang].declaracoes_at ?? 'Declarações AT'}
													dados={dados}
													language={language}
													lang={lang}
													onChangeHandlerFilesDoc={onChangeHandlerFilesDoc}
													handleDocRemove={handleDocRemove}
													edit_element_tree_doc={edit_element_tree_doc}
													open_link={open_link}
													copy_clipboard={copy_clipboard}
												/>
											</div>
										</div>
									</div>
								</div>

								<div className="card mt-5">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
										</div>
									</div>
									<div id="div_entidade_password" className="collapse show">
										<form id="form_pass" onSubmit={handleSubmitPassword}>

											<div className="card-body border-top p-4">

												<div className="row mb-6">
													<div className="col-md-4 fv-row">
														<label className="fs-6 fw-bold mb-2">{language[lang].username}</label>
														<input type="text" name="username" value={dados.current.info.username} pattern="[a-zA-Z\u00C0-\u00FF.]+" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} required />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-6 fw-bold mb-2">{language[lang].password}</label>
														<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-6 fw-bold mb-2">{language[lang].password_confirmation}</label>
														<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onBlur={handle_change_password} autoComplete="off" />
													</div>
												</div>

												<div className="card-footer d-flex justify-content-end py-6 px-9 d-none">
													<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
														<span>{language[lang].cancel}</span>
													</Link>

													<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
														<span>{language[lang].delete}</span>
													</button>

													<button type="submit" form="form_pass" className="btn btn-primary">
														<span>{language[lang].save}</span>
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>

							<div className="col-md-4 mb-5 mb-xl-10 d-none">
								<div className="card">
									<div className="card-header border-0" aria-expanded="true" aria-controls="kt_entidade_config">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].config}</h3>
										</div>
									</div>
									<div id="kt_entidade_config" className="collapse show">
										<form id="form-config" onSubmit={handleSubmitConfig}>

											<div className="card-body border-top p-3">

												<div className="row mb-6">
													<label className="fs-6 fw-bold mb-2">{language[lang].language}</label>

													<select className="form-select mb-3 mb-lg-0 rounded-0" aria-label="Select Language" name='language' defaultValue={dados.current.info.language} onChange={handle_change_info}>
														<option value="pt">PT</option>
														<option value="en">EN</option>
													</select>
												</div>

												<div className="row mb-6">
													<label className="form-check form-switch form-check-custom form-check-solid pulse pulse-success" htmlFor="kt_user_menu_dark_mode_toggle">
														<input
															id={'dark-mode-switch'}
															name="darkmode"
															className="form-check-input w-45px h-30px"
															type="checkbox"
															onChange={handleSingleCheckDarkmode}
															defaultChecked={dados.current.info.darkmode}
														/>
														<span className="pulse-ring ms-n1"></span>
														<span className="form-check-label text-gray-600 fs-7">Dark Mode</span>
													</label>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								{getTokenInfo().profile !== 'Gestor de Conteúdos' ? (
									<li className="nav-item">
										<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
											<i className="bi bi-chevron-left me-2"></i>
											<span>{language[lang].back}</span>
										</Link>
									</li>
								) : null}
								{getTokenInfo().profile !== 'Gestor de Conteúdos' ? (
									<li className={"nav-item " + show_delete_button}>
										<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
											<i className="bi bi-trash3 me-2"></i>
											<span>{language[lang].delete}</span>
										</button>
									</li>
								) : null}
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}

// Componente auxiliar reutilizável para os campos de upload de documentos (PDF)
// do clube: mostra o ficheiro já guardado (se existir), botão de escolha e botão
// de remoção — segue o mesmo padrão visual do upload do logótipo.
// Tabela unificada usada em Presidentes e Direção / Atletas / Outros Atletas —
// todas com as mesmas colunas, pela mesma ordem: Nº Federação, Nome, Perfil,
// Modalidades, Época, Tipo.
function ClubEntitiesTable({
	entities,
	language,
	lang,
	get_athlete_numero_federacao,
	get_entity_profile_labels,
	get_athlete_modalidades,
	get_entity_type_label,
	epoca_atual,
	highlightId,
	highlightLabel,
}) {
	return (
		<table className="table table-bordered align-middle">
			<thead>
				<tr>
					<th>{language[lang].numero_federacao ?? 'Nº Federação'}</th>
					<th>{language[lang].name}</th>
					<th>{language[lang].perfil ?? 'Perfil'}</th>
					<th>{language[lang].modalidades ?? 'Modalidades'}</th>
					<th>{language[lang].epoca ?? 'Época'}</th>
					<th>{language[lang].tipo ?? 'Tipo'}</th>
				</tr>
			</thead>
			<tbody>
				{entities.length > 0 ? (
					entities.map((el, k) => (
						<tr key={el.id ?? k}>
							<td>{get_athlete_numero_federacao(el)}</td>
							<td>
								{el.info?.name}
								{highlightId && String(highlightId) === String(el.id) && (
									<span className="badge bg-warning text-dark ms-2">{highlightLabel}</span>
								)}
							</td>
							<td>{get_entity_profile_labels(el) || '-'}</td>
							<td>{get_athlete_modalidades(el) || '-'}</td>
							<td>{epoca_atual}</td>
							<td>
								<span className={`badge ${get_entity_type_label(el) === (language[lang].interna ?? 'Interna') ? 'bg-primary' : 'bg-secondary'}`}>
									{get_entity_type_label(el)}
								</span>
							</td>
						</tr>
					))
				) : (
					<tr>
						<td colSpan="6" className="text-center text-muted">
							{language[lang].sem_registos ?? 'Sem registos'}
						</td>
					</tr>
				)}
			</tbody>
		</table>
	);
}

function DocUploadField({ field, label, dados, language, lang, onChangeHandlerFilesDoc, handleDocRemove, edit_element_tree_doc, open_link, copy_clipboard }) {
	const current = dados?.current?.info?.[field];
	const hasFile = Array.isArray(current) && current.length > 0;
	const treeData = hasFile ? [{ id: `${field}-1`, title: current[0].name, link: current[0].link, visible: true }] : [];

	return (
		<div className="p-3 bg-white shadow-sm rounded h-100">
			<label className="form-label fw-bold fs-6 d-block">{label}</label>

			<div className="mb-2">
				<input
					type="file"
					accept="application/pdf"
					data-field={field}
					onChange={onChangeHandlerFilesDoc}
					className="d-none"
					id={`doc-upload-${field}`}
				/>
				<label htmlFor={`doc-upload-${field}`} className="btn btn-outline-primary btn-sm">
					{language[lang].doc_choose ?? 'Escolher ficheiro'}
				</label>
			</div>

			{hasFile ? (
				<SortableTree
					isVirtualized={false}
					treeData={treeData}
					maxDepth={1}
					canDrag={false}
					onChange={() => { }}
					getNodeKey={({ node }) => node.id}
					generateNodeProps={extendedNode => ({
						title: (
							<input
								type="text"
								className="form-control form-control-sm rounded-0"
								defaultValue={extendedNode.node.title}
								onBlur={(e) => edit_element_tree_doc(field, e)}
							/>
						),
						buttons: [
							<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
							<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
							<button type="button" onClick={() => handleDocRemove(field)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
						],
					})}
				/>
			) : (
				<div className="text-muted mb-2">{language[lang].noFile ?? 'Sem ficheiro'}</div>
			)}
		</div>
	);
}